import React from "react"
import type { IFormBuilder, IFormBuilderConfig, IFormBuilderState } from "../interfaces/IDispatchFormBuilder"
import { createState, useState } from "@hookstate/core"
import { authFetch } from "~/services/fetch"
import useDispatchState from "./DispatchState"

export const formBuilderDefaultState: IFormBuilder = {
  id: null,
  description: null,
  name: null,
  form_groups: [{
    id: null,
    name: null,
    description: null,
    order: null,
    form_fields: [{
      id: null,
      name: null,
      type: null,
      options: null,
      order: null,
      is_required: false,
      date: null,
      date_time: null,
      is_active: false,
      value: null
    }]
  }],
}

const formConfigDefaultState: IFormBuilderConfig = {
  id: null,
  agency: null,
  form: null,
  is_required: false,
  item_type: null,
  type: null,
  subtype: null,
}

const formBuilderStore = Object.create(formBuilderDefaultState);
const formBuilderConfigStore = Object.create(formConfigDefaultState)

const store = createState<IFormBuilderState>({
  formBuilder: formBuilderStore,
  formBuilderConfig: formBuilderConfigStore,
})

export default function useDispatchFormBuilderState() {
  const formBuilder = useState(store.formBuilder);
  const formBuilderConfig = useState(store.formBuilderConfig)

  return {
    formBuilder: () => formBuilder,
    formBuilderConfig: () => formBuilderConfig,
    getFormConfig: async ({ typeId, subtypeId, agencyId }) => {
      const { data } = await authFetch({
        url: '/form-config/get-by-filters',
        method: 'POST',
        data: {
          type_id: typeId,
          subtype_id: subtypeId,
          agency_id: agencyId
        }
      })
      formBuilderConfig.set(data);
    },
    getFormWithValues: async ({itemId, formId}) => {
      const { data } = await authFetch({
        url: "/occurrence/associated-people/get-form-with-values",
        method: "POST",
        data: {
          item_id: itemId,
          form_id: formId
        }
      })
      
      return data
    },
    saveForm: async ({ itemId, formValues }) => {
      const { data } = await authFetch({
        url: '/occurrence/associated-people/store-form-values',
        method: 'POST',
        data: {
          item_id: itemId,
          form_values: formValues
        }
      })

      return data
    },
  }
}